<div class="modal-body">
  <div class="card">
    <div class="modal-header align-items-center justify-content-between">
      <div class="text-left m-0 p-0">Visualizar documento</div>
      <button
        type="button"
        class="modal-close close"
        aria-label="Close"
        (click)="activeModal.dismiss()"
      >
        <span class="material-symbols-rounded">close</span>
      </button>
    </div>
    <div class="modal-contenido">
      <div id="pdf-container"></div>
    </div>
  </div>
</div>
